import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/@/components/ui/dialog';
import { Input } from 'src/@/components/ui/input';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function ModalReasons({
  open,
  onClose,
  onSubmit,
  action,
  nome,
  changeNome,
}) {
  const { t } = useTranslation('settings');

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]" style={{ fontFamily: D.fontStack }}>
        <DialogHeader>
          <DialogTitle className={D.dialogTitle}>
            {action === 'Criar'
              ? t('funnel.reasons.modal.createTitle', 'Criar motivo de perda')
              : t('funnel.reasons.modal.editTitle', 'Editar motivo de perda')}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-5 py-2">
          <div className={D.field}>
            <label className={D.label}>{t('labels.name', { ns: 'common' })}</label>
            <Input onChange={changeNome} value={nome} className={D.input} />
            <p className={D.hint}>
              {t('funnel.reasons.modal.nameHint', 'Aparece quando a equipe marca um negócio como perdido.')}
            </p>
          </div>
        </div>
        <DialogFooter className={D.dialogFooter}>
          <button type="button" className={D.ghostButton} onClick={onClose}>
            {t('buttons.cancel', { ns: 'common' })}
          </button>
          <button type="button" className={D.primaryButton} onClick={onSubmit}>
            {action === 'Criar' ? t('buttons.create', { ns: 'common' }) : t('buttons.save', { ns: 'common' })}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
